import script from "./MoreCategorySheet.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreCategorySheet.vue?vue&type=script&setup=true&lang=js"

import "./MoreCategorySheet.vue?vue&type=style&index=0&id=5f027e83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f027e83"]])

export default __exports__